import { COMMA, CUSTOM, SEMICOLON, TAB } from '../constants';
import { DelimiterMode } from '../types';

export const resolveDelimiter = (
  delimiterMode: DelimiterMode,
  customDelimiter: string
): string => {
  switch (delimiterMode) {
    case COMMA:
      return ',';
    case SEMICOLON:
      return ';';
    case TAB:
      return '\t';
    case CUSTOM:
      return customDelimiter;
    default:
      return '\t';
  }
};
